import React, { useEffect, useState } from 'react'
import { Card, CardBody, CardHeader, Button, Modal, ModalHeader, ModalBody, Label, Input, FormGroup, ModalFooter } from "reactstrap"
import DataTable from 'react-data-table-component';
import { Api } from '../../../componentes/Api';
import * as moment from "moment";

const modelo = {

    cuadreID: 0,
    facturaID: '',
    fecha: new Date,
    montoFactura: 0.00,
    gastos:0.00,
    capital: 0.00,
    ganancia:0.00
}

export const CuadreAdmin = ({ data }) => {
    const [Lineas, SetLineas] = useState(modelo);
    const [LineasG, SetLineasG] = useState(modelo);
    const [ListadoLineas, SetListadoLineas] = useState([]);
    const [Listado, SetListado] = useState([]);

    useEffect(() => {
        obtenerDatosLineas();
        obtenerDatos()
    }, [])


    const obtenerDatos = async () => {
        let response = await fetch(Api + "VentasTrans/VerCuadreAdmin");
        if (response.ok) {
            let data1 = await response.json()
            SetListado(data1);
        }
    }
    const obtenerDatosLineas = async (pl) => {
        let response = await fetch(Api + "VentasTrans/ListaPedidoVentasLineas/" + data.pedidoID);
        if (response.ok) {
            let data1 = await response.json()
            //          SetListadoLineas(data) data.filter(x => !e.some(o => o.doctorID === x.doctorID))
            const nuevasLineas = data1.map(num => ({
                facturaID: data.facturaID,
                facturaLineaID: num.pedidoLineaID,
                fecha: num.fecha,
                articuloID: num.articuloID,
                descripcion: num.descripcionArticulo,
                montoFactura: num.totalLinea,
                gastos: 0.00,
                capital: 0.00,
                ganancia: 0.00
            }));
            SetListadoLineas(nuevasLineas);
        }
    }

    const GuardarCuadre = async (d) => {
        let response;
        d.ganancia =  d.montoFactura - (parseFloat(d.gastos) + parseFloat(d.capital)) 
        d.facturaID = d.facturaID + '';
        response = await fetch(Api + "VentasTrans/GuardarCuadre", {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(d)
            })

        if(response.ok) {
            let data1 = await response.json()
            obtenerDatosLineas()
            obtenerDatos()
        } else {
            alert("error al guardar")
        }

    }

   
    const toMoney = (value) => {
        const money = Number(value);
        if (isNaN(money)) {
            return value;
        }
        return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(money)
    }

    //Diseño tabla
    const customStyles = {
        headCells: {
            style: {
                fontSize: '13px',
                fontWeight: 800,
                paddingRight: '1px',
            },
        },
        headRow: {
            style: {
                backgroundColor: "#eee",
                minHeight: '30px',
            }
        }
    };
    const handleChange1 = (e, i) => {
        const value = e.target.value;
        const namev = e.target.name;
        const ga = (parseFloat(i.gastos) + parseFloat(i.capital)) - i.montoFactura
        const updatedImpactos = ListadoLineas.map(item => {
            if (item.facturaLineaID === i.facturaLineaID) {
                return { ...item, [namev]: value, ganancia: ga };
            }
            return item;
        });

        SetListadoLineas(updatedImpactos);

    }
    
    return (
        <>
       
            <table>
                <thead>
                    <tr>
                        <th>Descripcion</th>
                        <th>Monto</th>
                        <th>Gastos</th>
                        <th>Capital</th>
                        <th>Ganancias</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        (ListadoLineas.length < 1) ? (
                            <tr>
                                <td colSpan="7" style={{ textAlign: "center" }}>
                                    Sin resultados
                                </td>
                            </tr>
                        ) : (

                                ListadoLineas.map((item, x) => (
                                <tr key={item.facturaID}>
                                  

                                        <td>{item.descripcion}</td>
                                        <td>{toMoney(item.montoFactura)}</td>
                                        <td>{<Input type="number" bsSize="sm" name="gastos" onChange={(e) => handleChange1(e, item)} value={item.gastos} />}</td>
                                        <td>{<Input type="number" bsSize="sm" name="capital" onChange={(e) => handleChange1(e, item)} value={item.capital} />}</td>
                                        <td>{toMoney(item.montoFactura - (parseFloat(item.gastos) + parseFloat(item.capital)))} </td>
                                  
                                        <td> {(Listado.filter(x => x.facturaLineaID == item.facturaLineaID ).length == 0)&&
                                            <Button size="sm" color="info" outline
                                                onClick={() => GuardarCuadre(item)}
                                            >
                                                <i className="fa fa-eye" aria-hidden="true"></i> Guardar
                                            </Button>}
                                    </td>
                                </tr>
                            ))
                        )
                    }
                </tbody>
            </table>
        </>
    )
}
